export class ShareUserDetail {
  constructor() {
    this.account = new ShareAccount();
    /**
     * @type {ShareCompany[]}
     */
    this.company = [];
    this.groupCompanyFlag = false;
    this.isUpadatePassw = false;
    this.userCards = [];
    /**
     * @type {ShareUserDept[]}
     */
    this.userDept = [];
    this.userInfo = new ShareUserInfo();
  }
}

export class ShareAccount {
  constructor() {
    this.account = '';
    this.accountId = '';
    this.companyId = '';
    this.createTime = '';
    this.createUser = '';
    /**
     * @type {'Y'|'N'}
     */
    this.delFlag = 'N';
    this.infoId = '';
    this.password = '';
    this.salt = '';
    /**
     * @type {number}
     */
    this.status = 0;
    this.type = '';
    this.updateTime = '';
    this.updateUser = '';
  }
}

export class ShareCompany {
  constructor() {
    this.account = '';
    this.accountId = '';
    this.binCode = '';
    this.bussinessType = '';
    this.bussinessTypeCode = '';
    this.comCategory = '';
    this.companyId = '';
    /**
     * @type {'Y'|'N'}
     */
    this.default = 'N';
    this.groupType = '';
    this.groupTypeCode = '';
    this.infoId = '';
    this.logo = '';
    this.mark = '';
    this.name = '';
    this.shortName = '';
  }
}

export class ShareUserDept {
  constructor() {
    this.companyExternalDataCode = '';
    this.companyId = '';
    this.companyName = '';
    /**
     * @type {'Y'|'N'}
     */
    this.defaultFlag = 'N';
    this.deptExternalDataCode = '';
    this.deptId = '';
    this.deptName = '';
    this.duty = '';
    this.dutyName = '';
    this.infoId = '';
    this.userDeptGroup = '';
    this.userDeptId = '';
    this.userExternalDataCode = '';
    this.userName = '';
  }
}

export class ShareUserInfo {
  constructor() {
    this.account = '';
    this.accountId = '';
    this.avatar = '';
    this.avatarUrl = '';
    this.birthday = '';
    this.comCategory = '';
    this.companyId = '';
    this.companyIds = '';
    this.companyName = '';
    this.createTime = '';
    this.createUser = '';
    /**
     * @type {'Y'|'N'}
     */
    this.delFlag = 'N';
    this.deptExternalDataCode = '';
    this.deptId = '';
    this.deptIds = '';
    this.deptName = '';
    this.deptOrdered = '';
    this.duty = '';
    this.dutyName = '';
    this.email = '';
    this.englishName = '';
    this.englishSurName = '';
    this.externalDataCode = '';
    this.externalDataId = '';
    this.externalDutyCode = '';
    this.fullEnglishName = '';
    this.idCard = '';
    this.infoId = '';
    this.mobilePhone = '';
    this.name = '';
    this.nameAbbrevia = '';
    this.namePinyin = '';
    this.ordered = '';
    this.orgs = '';
    this.passPortDeadTime = '';
    this.passPortNo = '';
    this.passPortStartDate = '';
    this.passport = '';
    this.password = '';
    this.phone = '';
    this.political = '';
    this.politicalName = '';
    this.salt = '';
    this.sex = '';
    this.sexName = '';
    this.sortCode = 0;
    this.ssoAccount = '';
    /**
     * @type {number}
     */
    this.status = 0;
    this.statusMsg = '';
    this.updateTime = '';
    this.updateUser = '';
    this.appOrgTreeId = ''; // 新增：appOrgTreeId字段
  }
}

/*
  {
		"userCards":[],
		"userInfo":{
			"account":"mengxiangqi@CNCEC",
			"accountId":"bb7ad7a0799942fa83bea654dfc2059f",
			"avatar":"",
			"avatarUrl":"",
			"birthday":"1990-01-01",
			"comCategory":"1",
			"companyId":"1000000000000000000",
			"companyIds":"",
			"companyName":"中国化学工程集团（股份）有限公司",
			"createTime":"",
			"createUser":"",
			"delFlag":"N",
			"deptExternalDataCode":"BM000005",
			"deptId":"67da9b49a71545e5811cfd55b0093a93",
			"deptIds":"",
			"deptName":"党委办公室、总经理办公室",
			"deptOrdered":"5",
			"duty":"5a8e527dc31241fd8ce8fc0603ddeb92",
			"dutyName":"",
			"email":"mengxq@cncec.com.cn",
			"englishName":"xiangqi",
			"englishSurName":"meng",
			"externalDataCode":"",
			"externalDataId":"",
			"externalDutyCode":"",
			"fullEnglishName":"",
			"idCard":"1504***********512",
			"infoId":"fa82829ed6b241cc9a57ef476847053a",
			"mobilePhone":"139****8565",
			"name":"孟祥旗",
			"nameAbbrevia":"MXQ",
			"namePinyin":"MENGXIANGQI",
			"ordered":100,
			"orgs":"",
			"passPortDeadTime":"",
			"passPortNo":"",
			"passPortStartDate":"",
			"passport":"",
			"password":"",
			"phone":"",
			"political":"",
			"politicalName":"",
			"salt":"",
			"sex":"27575451ab8e4a02817be69e19dacae4",
			"sexName":"男",
			"sortCode":109010,
			"ssoAccount":"",
			"status":1,
			"statusMsg":"",
			"updateTime":"",
			"updateUser":""
		},
		"userDept":[
			{
				"companyExternalDataCode":"",
				"companyId":"1000000000000000000",
				"companyName":"中国化学工程集团（股份）有限公司",
				"defaultFlag":"Y",
				"deptExternalDataCode":"BM000005",
				"deptId":"67da9b49a71545e5811cfd55b0093a93",
				"deptName":"党委办公室、总经理办公室",
				"duty":"5a8e527dc31241fd8ce8fc0603ddeb92",
				"dutyName":"",
				"infoId":"fa82829ed6b241cc9a57ef476847053a",
				"userDeptGroup":"67da9b49a71545e5811cfd55b0093a935a8e527dc31241fd8ce8fc0603ddeb92",
				"userDeptId":"47dbb7d8be884a1b9e275f69dca97461",
				"userExternalDataCode":"2022000075",
				"userName":"孟祥旗"
			}
		],
		"company":[
			{
				"groupType":"内部企业",
				"infoId":"fa82829ed6b241cc9a57ef476847053a",
				"groupTypeCode":"1",
				"binCode":"CNCEC",
				"accountId":"bb7ad7a0799942fa83bea654dfc2059f",
				"companyId":"1000000000000000000",
				"bussinessType":"集团公司",
				"default":"Y",
				"comCategory":"1",
				"name":"中国化学工程集团（股份）有限公司",
				"logo":"4c1fd2f0911f4c5d9b935a038213a14c",
				"bussinessTypeCode":"1",
				"shortName":"集团股份公司",
				"account":"mengxiangqi@CNCEC",
				"mark":"12"
			}
		],
		"groupCompanyFlag":true,
		"isUpadatePassw":false,
		"account":{
			"account":"mengxiangqi@CNCEC",
			"accountId":"bb7ad7a0799942fa83bea654dfc2059f",
			"companyId":"1000000000000000000",
			"createTime":"2019-09-24 11:48:07",
			"createUser":"b02faf39066e4eff9ef93ccca2521691",
			"delFlag":"N",
			"infoId":"fa82829ed6b241cc9a57ef476847053a",
			"password":"",
			"salt":"",
			"status":1,
			"type":"1",
			"updateTime":"2023-09-18 19:06:24",
			"updateUser":"88daaa4d3318478c859ac1dbb8f80112"
		}
	}
 */
